import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings/styling';

export const carInfoDetailsStyling: CarInfoDetailsStyleParts = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '14px',
    fontWeight: 400,
    color: paletteBase.neutral400,
    '&:hover': {
      backgroundColor: paletteBase.neutralGrey200,
    },
  },
  headerText: {
    color: paletteBase.secondary400,
    paddingY: '4px',
    fontWeigt: 'inherit',
    fontSize: 'inherit',
  },
  costsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: 'inherit',
    color: 'inherit',
  },
  recentCost: {
    fontWeight: '400',
    fontSize: 'inherit',
    color: 'inherit',
  },
  deleteIcon: {
    width: '8.75px',
    height: '8.75px',
    stroke: paletteBase.semanticRed,
    cursor: 'pointer',
  },
};

export const deleteIconContainerStyling: AbgSxProps = {
  display: 'flex',
  width: '12px',
};

export const deleteIconStyling: AbgSxProps = {
  cursor: 'pointer',
  strokeWidth: '1px',
  width: '12px',
  height: '12px',
  stroke: paletteBase.red500,

  path: {
    fill: paletteBase.red500,
  },
};

export const checkoutMobileHeaderText: AbgSxProps = {
  color: paletteBase.secondary400,
  paddingY: 0,
  fontWeight: 400,
  fontSize: '14px !important',
};

export const checkoutMobileRecentCost: AbgSxProps = {
  fontWeight: 400,
  fontSize: '14px !important',
  color: paletteBase.secondary400,
};

export const checkoutMobileCarInfoWrapper: AbgSxProps = {
  marginTop: '6px',
};

export const gsoEstimatedText: AbgSxProps = {
  color: '#666',
  fontSize: '0.75rem',
};

type CarInfoDetailsStyleParts = {
  wrapper: AbgSxProps;
  headerText: AbgSxProps;
  costsContainer: AbgSxProps;
  recentCost: AbgSxProps;
  deleteIcon: AbgSxProps;
};
